import React from 'react';
import { useTranslation } from 'react-i18next';
import { Monitor } from 'lucide-react';
import { useWorkspaceQuery } from '../../hooks/queries';

/** Side panel note when the plan has no workspace. */
export const DesktopUpsell = ({ projectId }) => {
  const { t } = useTranslation();
  const { data } = useWorkspaceQuery(projectId);
  if (!data?.configured || data.available) return null;
  return (
    <section className="space-y-1.5">
      <h3 className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        <Monitor className="w-3.5 h-3.5" />{t('bots.desktop.title')}
      </h3>
      <p className="text-xs text-muted-foreground">{t('bots.desktop.pro_only')}</p>
    </section>
  );
};
